<template>
  <div>
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 400px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="orderItemsDefs"
        :rowData="orderItems"
        :localeText="localeText"
        @grid-ready="onGridReady"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
export default {
  components: {
    AgGridVue,
  },
  data() {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      orderItems: [],
      orderItemsDefs: [],
    };
  },
  props: {
    data: {
      default: () => {},
      required: true,
    },
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
  },
  watch: {
    data(val) {
      this.orderItemsDefs = [];
      this.orderItems = val;
      let columnList = Object.keys(this.orderItems[0]);
      columnList.forEach((val, index) => {
        if (
          val == "OrderItemBarcode" ||
          val == "OrderItemName" || 
          val == "OrderItemMarketPlaceCode"||
          val == "OrderNumber" ||
          val == "OrderItemQuantity"
					
        )
          this.orderItemsDefs.push({
            headerName: this.$t(val),
            field: val,
            pinned: "left",
            filter: "agSetColumnFilter",
            cellRendererFramework: "TextViewCellRenderer",
          });
        else if (!val.includes("Id")) {
          this.orderItemsDefs.push({
            headerName: this.$t(val),
            field: val,
            filter: "agSetColumnFilter",
            cellRendererFramework: "TextViewCellRenderer",
          });
        }
      });
      return val;
    },
  },
  computed: {
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
};
</script>
